module.exports = require("@nextcloud/capabilities");